import React, { useState, useContext, useRef, useEffect } from 'react';
import classStyle from './BrandDoc.module.scss';
import router from '@src/routes/router';
import logo from '@src/assets/logo.png';
import { ToastContext } from '@src/context';
import { QRCode } from 'react-qrcode-logo';
import { useWindowDimensions, useScreenshot, createFileName } from '@src/hooks';
import Highlighter from 'react-highlight-words';
import registerImg1 from '@src/assets/registerImg1.png';
import registerImg2 from '@src/assets/registerImg2.png';
import registerHint from '@src/assets/registerHint.png';
import collapseImg from '@src/assets/collapseImg.gif';
import { steps } from './brandDocData';

export default function BrandDoc() {
    const tabs = [
        {
            key: 'Download',
            title: '下载教程',
        },
        {
            key: 'Register',
            title: '注册教程',
        },
        {
            key: 'Merchant',
            title: '合作商户充提币教程',
        },
    ];
    const { type = 'Download' } = router.getQuery();
    const defaultType = tabs.find((v) => v.key === type) ? type : tabs[0].key;
    const [typeKey, setTypeKey] = useState(defaultType);
    const selectTab = tabs.find((v) => v.key === typeKey);
    const merchantCode = new URLSearchParams(window.location.search).get('merchantCode');

    return (
        <div className={classStyle.page}>
            <div className={classStyle.logoBar}>
                <img src={logo} className={classStyle.logo} alt="" />
                <div className={classStyle.logoTitle}>UBIT使用教程</div>
            </div>
            <div className={classStyle.tabs}>
                {tabs.map((tab) => (
                    <div
                        key={tab.key}
                        className={tab.key === typeKey ? classStyle.tabActive : classStyle.tab}
                        onClick={() => {
                            router.setQuery(
                                merchantCode != null
                                    ? { type: tab.key, merchantCode }
                                    : { type: tab.key },
                            );
                            setTypeKey(tab.key);
                        }}
                    >
                        {tab.title}
                    </div>
                ))}
            </div>
            {selectTab.key === 'Download' && <Download merchantCode={merchantCode} />}
            {selectTab.key === 'Register' && <Register />}
            {selectTab.key === 'Merchant' && <Merchant />}
        </div>
    );
}

function Download({ merchantCode }) {
    // eslint-disable-next-line no-unused-vars
    const [image, takeScreenshot] = useScreenshot();
    // 監聽視窗大小
    const { width } = useWindowDimensions();
    const screenRef = useRef(null);
    const toastContext = useContext(ToastContext);
    let downloadUrl = 'https://www.yubitusers.com';
    downloadUrl += merchantCode != null ? `?merchantCode=${merchantCode}` : '';
    const openLink = () => {
        const myWin = window.open(downloadUrl, '_blank');

        if (!myWin) {
            toastContext.setToast('弹出视窗遭阻拦，请至浏览器设置关闭阻拦', 1500);
        }
    };
    const onImgSave = async () => {
        const screenImage = await takeScreenshot(screenRef.current, {
            useCORS: true,
            scale: 2,
        });

        if (screenImage) {
            const a = document.createElement('a');
            a.href = screenImage;
            a.download = createFileName('png', '二维码' + downloadUrl);
            a.click();
        }
    };
    // const html = document.getElementsByTagName('html')[0];
    // const fontSize = window.getComputedStyle(html).fontSize.replace('px', '');
    let size = 200;

    if (width < 1200) {
        size = (width / 1200) * 200 * 1.4;
    }

    if (width < 768) {
        size = (width / 750) * 200 * 0.9;
    }

    return (
        <div className={classStyle.download}>
            <div className={classStyle.linkBar} onClick={openLink}>
                <div className={classStyle.linkButton}>下载链结</div>
                <div className={classStyle.linkBarText}>{downloadUrl}</div>
            </div>
            <div className={classStyle.downloadQR} ref={screenRef}>
                <QRCode value={downloadUrl} size={size} />
            </div>
            <div className={classStyle.downloadQRButton} onClick={onImgSave}>
                下载二维码
            </div>
            <div className={classStyle.downloadText}>根据下载网站的安装说明，完成安装。</div>
            <div className={classStyle.downloadImg} />
        </div>
    );
}

function Register() {
    return (
        <div className={classStyle.register}>
            <div className={classStyle.registerStepText}>
                {
                    '第一步：选择注册方式【手机号】【邮箱】；\n输入手机号码或邮箱、验证码、登录密码、二次确认登录密码。'
                }
            </div>
            <div className={classStyle.registerImgBar}>
                <img src={registerImg1} className={classStyle.registerImg} alt="" />
                <img src={registerImg2} className={classStyle.registerImg} alt="" />
            </div>
            <div className={classStyle.registerStepText}>
                {'第二步：建议注册前，阅读《用户服务协议》”'}
            </div>
            <img src={registerHint} className={classStyle.registerHint} alt="" />
            <div className={classStyle.registerStepText}>{'第三步：点击“注册”，完成注册。'}</div>
        </div>
    );
}

function Merchant() {
    const [openIndex, setOpenIndex] = useState(-1);

    return (
        <div className={classStyle.merchant}>
            {steps.map((step, i) => {
                const isOpen = openIndex === i;

                return (
                    <div key={step.key} className={classStyle.merchantItem}>
                        {!!step.text && <div className={classStyle.merchantText}>{step.text}</div>}
                        <div className={classStyle.merchantTitle}>{step.title}</div>
                        <div className={classStyle.merchantCard}>
                            {!isOpen && (
                                <img src={step.stepImg} className={classStyle.stepImg} alt="" />
                            )}
                            <div
                                className={
                                    isOpen
                                        ? classStyle.merchantContentOpen
                                        : classStyle.merchantContent
                                }
                            >
                                {step.list.map((item, i) => (
                                    <ContentItem key={i} item={item} />
                                ))}
                            </div>
                            <div
                                className={classStyle.collapse}
                                onClick={() => {
                                    setOpenIndex(isOpen ? -1 : i);
                                }}
                            >
                                <span>{isOpen ? '收起' : '展开详情'}</span>
                                <img
                                    src={collapseImg}
                                    className={
                                        isOpen ? classStyle.collapseImgOpen : classStyle.collapseImg
                                    }
                                    alt=""
                                />
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}

function ContentItem({ item }) {
    const { text, higlights = [], imgs = [] } = item;

    return (
        <div className={classStyle.contentItem}>
            <div className={classStyle.contentText}>
                <Highlighter
                    highlightStyle={{
                        color: '#B7292A',
                        backgroundColor: 'transparent',
                    }}
                    searchWords={higlights}
                    autoEscape={true}
                    textToHighlight={text}
                />
            </div>
            <div className={classStyle.contentImgBar}>
                {imgs.map((item, i) => (
                    <img
                        key={i}
                        src={item.img}
                        className={item.className ?? classStyle.contentImg}
                        alt=""
                    />
                ))}
            </div>
        </div>
    );
}
